import React from "react"
import { SpinIcon } from "@atos6/icons"
import { hvcenter } from "@atos6/ui"
import { useStore } from "../containers"

// FIXME: Mover para @atos e tornar independente de store
export function FullPageLoading() {
  const { isLoading } = useStore()
  return isLoading ? (
    <div style={style}>
      <SpinIcon />
    </div>
  ) : null
}

const fullscreen: Readonly<React.CSSProperties> = {
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 19876,
  backgroundColor: "#FFFFFFD0",
}

const style = {
  ...hvcenter,
  ...fullscreen,
}
